module.exports = __webpack_public_path__ + "static/img/email-send.1977181.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email-send.png
// module id = 555
// module chunks = 1